<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5> {{ $t('Results Aggregation')}} </h5>
    </b-card-header>
    <b-card-body>
      <b-row>

        <b-col md="12" sm="12" lg="6" class="mb-md-0 mb-2 pb-50">

          <b-form-checkbox v-model=isEnabled>{{ $t('RESULTS_AGGREGATION_ENABLED_CHECKBOX_LABEL') }}</b-form-checkbox>

        </b-col>

      </b-row>

      <b-row>

        <b-col md="12" sm="12" lg="6" class="mb-md-0 mb-2">

          <label>{{ $t('Period') }}</label>

          <v-select 
                :dir="$store.getters['auth/preferDirIsRtl']  ? 'rtl' : 'ltr'"
                label="name"
                :options="periodOptions.map(p=>({id:p.split(' ').join('_').toLowerCase(),name:$t(p)}))"
                v-model="selectedPeriod"
                class="w-100"
                :reduce="val=>val.id"
          />
          <small v-if="errors && ('period' in errors)" class="text-danger">
              {{ $t(errors['period'][0]) }}
          </small>

        </b-col>

        <b-col md="12" sm="12" lg="6" class="mb-md-0 mb-2">

          <label>{{ $t('Fields') }}</label>
          <v-select
                multiple
                :close-on-select="false"
                :dir="$store.getters['auth/preferDirIsRtl']  ? 'rtl' : 'ltr'"
                label="name"
                :options="groupByOptions.map((field)=> {
                  if(typeof field === 'string' || field instanceof String){
                    return {id:field.toLowerCase(),name:$t(field)}
                  }
                  return {id:field.key,name:$t(field.label)}
                })"
                v-model="selectedGroupBy"
                class="w-100"
                :reduce="val=>val.id"
          />
          <small v-if="errors && ('groupBy' in errors)" class="text-danger">
              {{ $t(errors['groupBy'][0]) }}
          </small>

        </b-col>
        
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>

import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BFormCheckbox
} from 'bootstrap-vue'

import vSelect from 'vue-select'

import { ref, computed } from '@vue/composition-api'

export default {
  components: {
    BRow,
    BCol,
    BFormCheckbox,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect
  },

  props:{
    enabled:{
      type:Boolean
    },
    period:{
      type:String
    },
    groupBy:{
      type:Array
    },
    errors:{
      type:Object
    },
     groupByOptions:{
      type:Array    
    }
  },
  setup( props , { emit }){

    const periodOptions = ref(['Day','Week','Month','Quarter','Year','Entire Period']);

    const isEnabled = computed({
      get(){
        return props.enabled
      },
      set(value){
        emit('update:enabled' , value)
      }
    });

    const selectedPeriod = computed({
      get(){
        return props.period
      },
      set(value){
        emit('update:period' , value)
      }
    });

    const selectedGroupBy = computed({
      get(){
        return props.groupBy
      },
      set(value){
        emit('update:groupBy' , value)
      }
    });

    selectedGroupBy.value = props.groupByOptions;

    return {isEnabled, selectedPeriod , selectedGroupBy, periodOptions}

  }

}

</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
